import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ktostamm-kunde-subnummer-template',
  imports: [],
  templateUrl: './ktostamm-kunde-subnummer.template.html',
  styleUrls: ['./ktostamm-kunde-subnummer.template.css'],
})
export class KtostammKundeSubnummerTemplate implements FieldOkItemComponent<any> {
  @Input() item: any;
}
